import React, { useState, useEffect } from 'react'; // এখানে useEffect ইমপোর্ট হয়েছে
import { db } from '../firebaseConfig';
import { collection, setDoc, doc, getDocs } from 'firebase/firestore'; 

const NewsEditor = () => {
	const [subCategories, setSubCategories] = useState([]);
  const [news, setNews] = useState({ 
  title: '', 
  content: '', 
  category: '', 
  subcategory: '',
  image: '', 
  caption: '',      
  reporterName: '',
  tags: ''  
});

const generateShortId = () => {
  return Math.floor(10000 + Math.random() * 90000).toString();
};

  const [menuCategories, setMenuCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tagsInput, setTagsInput] = useState("");
  // ক্যাটাগরি লোড করার ইফেক্ট (আপডেট করা)
  useEffect(() => {
  const fetchCategories = async () => {
    try {
      // ডেটাবেস থেকে ক্যাটাগরি আনুন
      const querySnapshot = await getDocs(collection(db, "categories"));
      
      const cats = querySnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => Number(a.order || 0) - Number(b.order || 0));

      setMenuCategories(cats);
      
      // ডিফল্ট ক্যাটাগরি সিলেক্ট করা
      if (cats.length > 0) {
        setNews(prev => ({ ...prev, category: cats[0].name }));
      }
    } catch (error) {
      console.error("Error fetching categories: ", error);
    }
  };

  fetchCategories();
}, []);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('image', file);
    const apiKey = '874aba0b22e62f51c225a6c83f3f6da5'; 
    try {
      const response = await fetch(`https://api.imgbb.com/1/upload?key=${apiKey}`, { method: 'POST', body: formData });
      const data = await response.json();
      setNews({ ...news, image: data.data.url });
      alert("ছবি আপলোড হয়েছে!");
    } catch (error) { alert("ছবি আপলোডে সমস্যা!"); }
  };

const handlePublish = async () => { 
  setLoading(true);
  try {
    const tagArray = news.tags ? news.tags.split(",").map(tag => tag.trim()).filter(tag => tag !== "") : [];
    const selectedCategory = menuCategories.find(
  (cat) => cat.name === news.category
);

const categorySlug = selectedCategory?.slug || "";

const subcategorySlug =
  selectedCategory?.subcategorySlugs?.[
    selectedCategory.subcategories?.indexOf(news.subcategory)
  ] || "";
    // ৫ ডিজিটের আইডি তৈরি
    const shortId = generateShortId(); 
    
    // ডাটাবেসে নিজস্ব আইডি (shortId) দিয়ে সেভ করা
    await setDoc(doc(db, "news", shortId), {
      title: news.title,
      content: news.content,
      category: news.category,
      subcategory: news.subcategory,
	  categorySlug: categorySlug,
      subcategorySlug: subcategorySlug,
      image: news.image,
      caption: news.caption,
      reporterName: news.reporterName,
      tags: tagArray,
      status: 'active',
      timestamp: new Date(),
      id: shortId 
    });
    
    alert("প্রকাশিত হয়েছে!");
    
    // রিসেট করার সময় ক্যাটাগরি ঠিকভাবে সেট করা হলো
    setNews({ 
      title: '', 
      content: '', 
      category: menuCategories.length > 0 ? menuCategories[0].name : '', 
      subcategory: '',
      image: '', 
      caption: '', 
      reporterName: '', 
      tags: ''
    });
    setSubCategories([]); // সাব-ক্যাটাগরিও খালি করে দেয়া ভালো
  } catch (error) {
    console.error("Error adding document: ", error);
    alert("আপলোড ব্যর্থ হয়েছে!");
  }
  setLoading(false);
};


const [isBtnHovered, setIsBtnHovered] = useState(false);

const handleCategoryChange = (selectedCategory) => {
  const selectedCatObj = menuCategories.find(c => c.name === selectedCategory);
  setNews(prev => ({ ...prev, category: selectedCategory, subcategory: '' })); 
  setSubCategories(selectedCatObj ? selectedCatObj.subcategories || [] : []);
};

  return (
  <div>
    <h3 style={{ marginBottom: '20px', borderBottom: '2px solid #d2202a', paddingBottom: '10px' }}>নিউজ এডিটর</h3>
    
    {/* গ্রিড কন্টেইনার: ২ কলামে সাজানো হলো */}
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
      
      {/* বাম পাশ */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <input placeholder="শিরোনাম" value={news.title} onChange={(e) => setNews({...news, title: e.target.value})} style={{ padding: '12px' }} />
	<input 
  placeholder="ট্যাগ লিখুন (কমা দিয়ে আলাদা করুন, যেমন:রাজনীতি,বিএনপি,সংসদ সদস্য)" 
  value={news.tags} 
  onChange={(e) => setNews({...news, tags: e.target.value})} 
  style={{ padding: '12px', marginTop: '10px', width: '100%' }} 
/>
        <input type="file" onChange={handleImageUpload} style={{ padding: '10px', border: '1px dashed #ccc' }} />
        <input placeholder="ছবির ক্যাপশন" value={news.caption} onChange={(e) => setNews({...news, caption: e.target.value})} style={{ padding: '12px' }} />
      </div>

     {/* ডান পাশ */}
<div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
  <input placeholder="প্রতিবেদকের নাম" value={news.reporterName} onChange={(e) => setNews({...news, reporterName: e.target.value})} style={{ padding: '12px' }} />
  
  {/* ক্যাটাগরি সিলেক্ট */}
  <select value={news.category} onChange={(e) => handleCategoryChange(e.target.value)} style={{ padding: '12px' }}>
    {menuCategories.map(cat => <option key={cat.id} value={cat.name}>{cat.name}</option>)}
  </select>

  {/* সাব-ক্যাটাগরি সিলেক্ট (যদি থাকে) */}
  {subCategories.length > 0 && (
    <select value={news.subcategory} onChange={(e) => setNews({...news, subcategory: e.target.value})} style={{ padding: '12px' }}>
      <option value="">সাব-ক্যাটাগরি সিলেক্ট করুন</option>
      {subCategories.map((sub, index) => <option key={index} value={sub}>{sub}</option>)}
    </select>
  )}
</div>
</div>
   <div style={{ marginTop: '20px' }}>
 <textarea
  placeholder="বিস্তারিত..."
  value={news.content}
  onChange={(e) =>
    setNews({ ...news, content: e.target.value })
  }
  onInput={(e) => {
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
  }}
  style={{
    width: '100%',
    minHeight: '30px',
    padding: '12px',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box',
    resize: 'none', // চাইলে vertical-ও রাখতে পারো
    overflow: 'hidden'
  }}
/>
</div>

   <button 
  onClick={handlePublish} 
  disabled={loading} 
  onMouseEnter={() => setIsBtnHovered(true)} 
  onMouseLeave={() => setIsBtnHovered(false)}
  style={{ 
    width: '100%', 
    padding: '15px', 
    marginTop: '20px', 
   background: isBtnHovered ? '#8b0000' : '#888', // হোভার করলে গাঢ় লাল
    color: '#fff', 
    fontSize: '20px', 
    cursor: 'pointer', 
    border: 'none',
    borderRadius: '4px', // একটু স্মুথ করার জন্য
    transition: 'background 0.3s ease' // রঙ পরিবর্তনের সময়টা স্মুথ হবে
  }}
>
  {loading ? "প্রকাশিত হচ্ছে..." : "প্রকাশ করুন"}
</button>
  </div>
);
};

export default NewsEditor;